import React from 'react';
import Tophead from '../templates/tophead';
function Governingbody(){
    return(
      <div>
         <Tophead/>
         dsafdgfvh657
      </div>
    )
}
export default Governingbody;

